module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan1-1-d6c2fd0d453578572c37b882b8648cf1.webp";